import { useState, type ReactNode } from 'react';
import { ApiError } from '@avs/contract';
import { API_MODE } from '../api/client.js';
import { useMe, redeemAndRefresh } from '../hooks/useMe.js';
import { Icon } from '../icons/Icon.js';
import { Button } from './Button.js';
import { showToast } from '../hooks/useToasts.js';

/**
 * 邀请码闸门：real 模式下，未激活的用户挡在这里，输入邀请码才能进工作台。
 * mock 模式（演示链接）直接放行。
 */
export function InviteGate({ children }: { children: ReactNode }) {
  const { me, loading } = useMe();
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // mock 模式不门禁
  if (API_MODE !== 'real') return <>{children}</>;

  if (loading) {
    return (
      <div className="gate">
        <div className="gate-card"><div className="muted">连接中…</div></div>
      </div>
    );
  }

  if (me?.activated) return <>{children}</>;

  async function redeem() {
    if (!code.trim()) return;
    setSubmitting(true);
    try {
      const m = await redeemAndRefresh(code.trim());
      showToast(`激活成功，获得 ${m.credits} 额度`, 'ok');
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : '激活失败';
      showToast(msg, 'err');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="gate">
      <div className="gate-card">
        <div className="gate-logo"><Icon name="video" size={22} /></div>
        <h1 className="gate-title">AI 视频创作 Studio</h1>
        <p className="gate-sub">当前为受邀内测。输入邀请码激活账户，即可开始批量视频替换。</p>
        <div className="gate-form">
          <input
            className="input"
            placeholder="邀请码，例如 DEMO2026"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') void redeem(); }}
            autoFocus
          />
          <Button variant="primary" onClick={() => void redeem()} disabled={submitting || !code.trim()}>
            {submitting ? '激活中…' : '激活'}
          </Button>
        </div>
        <div className="gate-foot muted">没有邀请码？联系管理员获取。</div>
      </div>
    </div>
  );
}
